import {
  CertificateProgram,
  CertificateProgramProduct,
  CertificateTile,
} from '@mc/api'
import paintedDoorV2Catalog from './paintedDoorV2Catalog.json'

type PaintedDoorCertificateCard = CertificateTile & { isPaintedDoor: true }

type PaintedDoorCertificateData = {
  card: PaintedDoorCertificateCard
  program: CertificateProgram
  product: CertificateProgramProduct
}

const PAINTED_DOOR_DATA: PaintedDoorCertificateData[] =
  paintedDoorV2Catalog.map(({ card, program, product }) => ({
    card: {
      ...(card as unknown as CertificateTile),
      isPaintedDoor: true,
    },
    program: program as unknown as CertificateProgram,
    product: product as unknown as CertificateProgramProduct,
  }))

export type PaintedDoorCertificateTile = PaintedDoorCertificateCard

/** Helper to check if a slug is a painted door certificate */
export const isPaintedDoorSlug = (slug: string): boolean =>
  PAINTED_DOOR_DATA.some((cert) => cert.card.slug === slug)

/** Tiles for carousel display (derived from master data) */
export const PAINTED_DOOR_CARD_CONTENT: PaintedDoorCertificateTile[] =
  PAINTED_DOOR_DATA.map((cert) => cert.card)

/** Programs keyed by slug (derived from master data) */
export const PAINTED_DOOR_PROGRAMS: Record<string, CertificateProgram> =
  Object.fromEntries(
    PAINTED_DOOR_DATA.map(({ program }) => [program.slug, program]),
  )

/** Products keyed by slug (derived from master data) */
export const PAINTED_DOOR_PRODUCTS: Record<string, CertificateProgramProduct> =
  Object.fromEntries(
    PAINTED_DOOR_DATA.map(({ product }) => [product.slug, product]),
  )
